import * as React from 'react';
import {
    Edit,
    BooleanInput,
    TextInput,
    SimpleForm,
    required,
} from 'react-admin';
import { Grid } from '@mui/material';
import { RichTextInput } from '../../components/RichTextInput';

import Aside from './Aside';
import FullNameField from './FullNameField';

const req = [required()];

const EntityEdit = () => {
    return (
        <Edit
            title={<EditTitle />}
            aside={<Aside />}
            redirect={false}
            mutationMode="pessimistic"
        >
            <SimpleForm>
                <div>
                    <Grid
                        container
                        width={{ xs: '100%', xl: '80%' }}
                        spacing={2}
                    >
                        <Grid item xs={12} md={10} xl={12}>
                            <TextInput
                                source="title"
                                isRequired
                                validate={req}
                                fullWidth
                            />
                            <BooleanInput source="active" fullWidth />
                            <TextInput source="element" fullWidth />
                            <TextInput source="slug" fullWidth />
                            <TextInput source="link" fullWidth />
                            <RichTextInput source="content" fullWidth />
                        </Grid>
                    </Grid>
                </div>
            </SimpleForm>
        </Edit>
    );
};

// @ts-ignore
const EditTitle = () => <FullNameField size="32" sx={{ margin: '5px 0' }} />;

export default EntityEdit;
